'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGridSize = undefined;

var _gridConstants = require('./gridConstants');

var setGridSize = exports.setGridSize = function setGridSize(gridSize, sizeName) {
  return { type: _gridConstants.GRID_RESIZE, gridSize: gridSize, sizeName: sizeName };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/grid/gridActions.js
// module id = 2124
// module chunks = 0